/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Email/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import Emails from './Emails/index'
import Heading from './Heading/index'
import NewEmail from './NewEmail/index'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Email({
  children,
  viewPath = "/DesignSystem/DataVaxiomEmployeeProfessionalsRelationshipsItem/Edit/Content/Email"
  
}) {
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
  return (<React.Fragment
>
<div
  data-testid="Email.Vertical"
  data-view-path={viewPath}
 style={{'--mb-1-4PsPS': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--mt-2-4PsPS': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Vertical}`}
>
<Heading
  viewPath={`${viewPath}/Heading`}
/>
<Emails
  viewPath={`${viewPath}/Emails`}
/>
</div>
<NewEmail
  viewPath={`${viewPath}/NewEmail`}
/>
{children}
</React.Fragment>)
}